import { render, staticRenderFns } from "./MessageLoadingSkeleton.vue?vue&type=template&id=4884dd58&scoped=true"
import script from "./MessageLoadingSkeleton.vue?vue&type=script&lang=js"
export * from "./MessageLoadingSkeleton.vue?vue&type=script&lang=js"
import style0 from "./MessageLoadingSkeleton.vue?vue&type=style&index=0&id=4884dd58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4884dd58",
  null
  
)

export default component.exports